// compute a unique identifier for two collections of topics using the ID +
// what could change while the user is using the page (for now the "join" status)
// for a low cost (200 μs for 200 topics)
const getUniqueKeyForTopics = (topics) =>
  topics.reduce((p, topic) => `${p}|${topic.id}_${!!topic.joined_at}`, '');

export default getUniqueKeyForTopics;
